<template>
  <v-app>
    <AllowedUserAuthContainer :page-types="['admin', 'manager']" >
      <SessionShareContainer />
      <master-admin-header />
      <v-main>
        <div
          class="d-flex justify-space-between"
          style="position: relative; margin-top: 70px"
        >
          <template v-if="true">
            <!-- # TODO: 切り変えられる仕組みを考える -->
            <router-view name="subSidebar" />
            <router-view />
          </template>

          <template v-else>
            <v-overlay>
              <v-progress-circular indeterminate size="64" z-index="2000" />
            </v-overlay>
          </template>
        </div>
        <slot />
      </v-main>
    </AllowedUserAuthContainer>
    <toaster />
    <loading-overlay />
  </v-app>
</template>

<script>
import MasterAdminHeader from '/src/container/shared/MasterAdminHeader'
import Toaster from '@/components/commons/Toaster'
import LoadingOverlay from '@/components/commons/LoadingOverlay'
import { mapState } from 'vuex'
import AllowedUserAuthContainer from '../../src/container/shared/AllowedUserAuthContainer'
import SessionShareContainer from '../../src/container/shared/SessionShare'

export default {
  name: 'App',
  components: {
    SessionShareContainer,
    AllowedUserAuthContainer,
    MasterAdminHeader,
    Toaster,
    LoadingOverlay
  },
  computed: {
    ...mapState({
      currentUserAuth: (state) => {
        return state.UserAuthStore.currentUserAuth
      }
    })
  }
}
</script>
